const Shimmer = () => {
  return <div className="shimmer">&nbsp;</div>;
};

export default Shimmer;
